<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<script lang="ts">
  import {
    getDisplay,
    getValue,
    type GameraTeamReference,
  } from '@statmuse/core/gamera'
  import TeamPanel from '../common/team-panel.svelte'
  import { teamStats } from './stores'
  import Icon from '@components/icon.svelte'
  import TeamStats from './team-stats.svelte'

  export let awayTeam: GameraTeamReference | undefined
  export let homeTeam: GameraTeamReference | undefined

  let expanded = false

  $: awayTeamStats =
    $teamStats.away?.statsLookup[$teamStats.away?.statsLookupKey ?? '']
  $: homeTeamStats =
    $teamStats.home?.statsLookup[$teamStats.home?.statsLookupKey ?? '']
</script>

{#if expanded}
  <TeamStats {awayTeam} {homeTeam} />
{:else}
  <TeamPanel {awayTeam} {homeTeam} title="Team Stats">
    <div
      class="border-t border-gray-6 dark:border-gray-4 divide-y divide-gray-6 dark:divide-gray-4 *:px-1 *:py-1"
    >
      <div class="flex justify-center relative">
        <p
          class="absolute top-1 left-1 px-2 rounded-2xl"
          style={getValue(awayTeamStats ?? {}, 'FieldGoalPercentage') >
          getValue(homeTeamStats ?? {}, 'FieldGoalPercentage')
            ? `background:${awayTeam?.colors?.backgroundColor};color:${awayTeam?.colors?.foregroundColor};`
            : undefined}
        >
          <span
            class:text-gray-5={getValue(
              awayTeamStats ?? {},
              'FieldGoalPercentage',
            ) <= getValue(homeTeamStats ?? {}, 'FieldGoalPercentage')}
            class:opacity-50={getValue(
              awayTeamStats ?? {},
              'FieldGoalPercentage',
            ) > getValue(homeTeamStats ?? {}, 'FieldGoalPercentage')}
          >
            {`${getDisplay(awayTeamStats ?? {}, 'FieldGoalsMade')}-${getDisplay(
              awayTeamStats ?? {},
              'FieldGoalsAttempted',
            )}`}
          </span>
          ({getDisplay(awayTeamStats ?? {}, 'FieldGoalPercentage')}%)
        </p>
        <p class="text-gray-5">FG%</p>
        <p
          class="absolute top-1 right-1 px-2 rounded-2xl"
          style={getValue(homeTeamStats ?? {}, 'FieldGoalPercentage') >
          getValue(awayTeamStats ?? {}, 'FieldGoalPercentage')
            ? `background:${homeTeam?.colors?.backgroundColor};color:${homeTeam?.colors?.foregroundColor};`
            : undefined}
        >
          <span
            class:text-gray-5={getValue(
              homeTeamStats ?? {},
              'FieldGoalPercentage',
            ) <= getValue(awayTeamStats ?? {}, 'FieldGoalPercentage')}
            class:opacity-50={getValue(
              homeTeamStats ?? {},
              'FieldGoalPercentage',
            ) > getValue(awayTeamStats ?? {}, 'FieldGoalPercentage')}
          >
            {`${getDisplay(homeTeamStats ?? {}, 'FieldGoalsMade')}-${getDisplay(
              homeTeamStats ?? {},
              'FieldGoalsAttempted',
            )}`}
          </span>
          ({getDisplay(homeTeamStats ?? {}, 'FieldGoalPercentage')}%)
        </p>
      </div>

      <div class="flex justify-center relative">
        <p
          class="absolute top-1 left-1 px-2 rounded-2xl"
          style={getValue(awayTeamStats ?? {}, 'ThreePointsMade') >
          getValue(homeTeamStats ?? {}, 'ThreePointsMade')
            ? `background:${awayTeam?.colors?.backgroundColor};color:${awayTeam?.colors?.foregroundColor};`
            : undefined}
        >
          {`${getDisplay(awayTeamStats ?? {}, 'ThreePointsMade')}-${getDisplay(
            awayTeamStats ?? {},
            'ThreePointsAttempted',
          )}`}
          <span
            class:text-gray-5={getValue(
              awayTeamStats ?? {},
              'ThreePointsMade',
            ) <= getValue(homeTeamStats ?? {}, 'ThreePointsMade')}
            class:opacity-50={getValue(awayTeamStats ?? {}, 'ThreePointsMade') >
              getValue(homeTeamStats ?? {}, 'ThreePointsMade')}
          >
            ({getDisplay(awayTeamStats ?? {}, 'ThreePointPercentage')}%)
          </span>
        </p>
        <p class="text-gray-5">3PM</p>
        <p
          class="absolute top-1 right-1 px-2 rounded-2xl"
          style={getValue(homeTeamStats ?? {}, 'ThreePointsMade') >
          getValue(awayTeamStats ?? {}, 'ThreePointsMade')
            ? `background:${homeTeam?.colors?.backgroundColor};color:${homeTeam?.colors?.foregroundColor};`
            : undefined}
        >
          {`${getDisplay(homeTeamStats ?? {}, 'ThreePointsMade')}-${getDisplay(
            homeTeamStats ?? {},
            'ThreePointsAttempted',
          )}`}
          <span
            class:text-gray-5={getValue(
              homeTeamStats ?? {},
              'ThreePointsMade',
            ) <= getValue(awayTeamStats ?? {}, 'ThreePointsMade')}
            class:opacity-50={getValue(homeTeamStats ?? {}, 'ThreePointsMade') >
              getValue(awayTeamStats ?? {}, 'ThreePointsMade')}
          >
            ({getDisplay(homeTeamStats ?? {}, 'ThreePointPercentage')}%)
          </span>
        </p>
      </div>

      <div class="flex justify-center relative">
        <p
          class="absolute top-1 left-1 px-2 rounded-2xl"
          style={getValue(awayTeamStats ?? {}, 'FreeThrowsMade') >
          getValue(homeTeamStats ?? {}, 'FreeThrowsMade')
            ? `background:${awayTeam?.colors?.backgroundColor};color:${awayTeam?.colors?.foregroundColor};`
            : undefined}
        >
          {`${getDisplay(awayTeamStats ?? {}, 'FreeThrowsMade')}-${getDisplay(
            awayTeamStats ?? {},
            'FreeThrowsAttempted',
          )}`}
          <span
            class:text-gray-5={getValue(
              awayTeamStats ?? {},
              'FreeThrowsMade',
            ) <= getValue(homeTeamStats ?? {}, 'FreeThrowsMade')}
            class:opacity-50={getValue(awayTeamStats ?? {}, 'FreeThrowsMade') >
              getValue(homeTeamStats ?? {}, 'FreeThrowsMade')}
          >
            ({getDisplay(awayTeamStats ?? {}, 'FreeThrowPercentage')}%)
          </span>
        </p>
        <p class="text-gray-5">FTM</p>
        <p
          class="absolute top-1 right-1 px-2 rounded-2xl"
          style={getValue(homeTeamStats ?? {}, 'FreeThrowsMade') >
          getValue(awayTeamStats ?? {}, 'FreeThrowsMade')
            ? `background:${homeTeam?.colors?.backgroundColor};color:${homeTeam?.colors?.foregroundColor};`
            : undefined}
        >
          {`${getDisplay(homeTeamStats ?? {}, 'FreeThrowsMade')}-${getDisplay(
            homeTeamStats ?? {},
            'FreeThrowsAttempted',
          )}`}
          <span
            class:text-gray-5={getValue(
              homeTeamStats ?? {},
              'FreeThrowsMade',
            ) <= getValue(awayTeamStats ?? {}, 'FreeThrowsMade')}
            class:opacity-50={getValue(homeTeamStats ?? {}, 'FreeThrowsMade') >
              getValue(awayTeamStats ?? {}, 'FreeThrowsMade')}
          >
            ({getDisplay(homeTeamStats ?? {}, 'FreeThrowPercentage')}%)
          </span>
        </p>
      </div>

      <div class="flex justify-center relative">
        <p
          class="absolute top-1 left-1 px-2 rounded-2xl"
          style={getValue(awayTeamStats ?? {}, 'Rebounds') >
          getValue(homeTeamStats ?? {}, 'Rebounds')
            ? `background:${awayTeam?.colors?.backgroundColor};color:${awayTeam?.colors?.foregroundColor};`
            : undefined}
        >
          {getDisplay(awayTeamStats ?? {}, 'Rebounds')}
        </p>
        <p class="text-gray-5">Rebounds</p>
        <p
          class="absolute top-1 right-1 px-2 rounded-2xl"
          style={getValue(homeTeamStats ?? {}, 'Rebounds') >
          getValue(awayTeamStats ?? {}, 'Rebounds')
            ? `background:${homeTeam?.colors?.backgroundColor};color:${homeTeam?.colors?.foregroundColor};`
            : undefined}
        >
          {getDisplay(homeTeamStats ?? {}, 'Rebounds')}
        </p>
      </div>

      <div class="flex justify-center relative">
        <p
          class="absolute top-1 left-1 px-2 rounded-2xl"
          style={getValue(awayTeamStats ?? {}, 'Assists') >
          getValue(homeTeamStats ?? {}, 'Assists')
            ? `background:${awayTeam?.colors?.backgroundColor};color:${awayTeam?.colors?.foregroundColor};`
            : undefined}
        >
          {getDisplay(awayTeamStats ?? {}, 'Assists')}
        </p>
        <p class="text-gray-5">Assists</p>
        <p
          class="absolute top-1 right-1 px-2 rounded-2xl"
          style={getValue(homeTeamStats ?? {}, 'Assists') >
          getValue(awayTeamStats ?? {}, 'Assists')
            ? `background:${homeTeam?.colors?.backgroundColor};color:${homeTeam?.colors?.foregroundColor};`
            : undefined}
        >
          {getDisplay(homeTeamStats ?? {}, 'Assists')}
        </p>
      </div>

      <div class="flex justify-center relative">
        <p
          class="absolute top-1 left-1 px-2 rounded-2xl"
          style={getValue(awayTeamStats ?? {}, 'Turnovers') <
          getValue(homeTeamStats ?? {}, 'Turnovers')
            ? `background:${awayTeam?.colors?.backgroundColor};color:${awayTeam?.colors?.foregroundColor};`
            : undefined}
        >
          {getDisplay(awayTeamStats ?? {}, 'Turnovers')}
        </p>
        <p class="text-gray-5">Turnovers</p>
        <p
          class="absolute top-1 right-1 px-2 rounded-2xl"
          style={getValue(homeTeamStats ?? {}, 'Turnovers') <
          getValue(awayTeamStats ?? {}, 'Turnovers')
            ? `background:${homeTeam?.colors?.backgroundColor};color:${homeTeam?.colors?.foregroundColor};`
            : undefined}
        >
          {getDisplay(homeTeamStats ?? {}, 'Turnovers')}
        </p>
      </div>

      <div class="flex justify-center relative text-gray-5">
        <p
          class="hidden @xl/boxscore:flex gap-1.5 items-center cursor-pointer"
          on:click={() => (expanded = true)}
        >
          <span>See more</span>
          <Icon name="dropdown" class="w-5 h-5 mt-0.5" />
        </p>
        <label
          for="team-stats"
          class="flex @xl/boxscore:hidden gap-1.5 items-center cursor-pointer"
          on:click={() => window.scrollTo(0, 0)}
        >
          <span>See more</span>
          <Icon name="next" class="w-5 h-5 mt-0.5" />
        </label>
      </div>
    </div>
  </TeamPanel>
{/if}
